import {
  FormTemplate as Data,
  FormTemplateCollection as Collection,
} from '@/typings/api/FormTemplate'

import { DataCollection, UploadTemplateResponse } from '@/typings/api/DataCollection'

import { BaseLkApiAuth } from '@/api/BaseApiAuth'
import { AxiosRequestConfig } from 'axios'
import { BaseApiResponse as BR } from '@/typings/common'


export class LkDataCollectionsApi extends BaseLkApiAuth<Data, Collection> {
  protected readonly endpoint = 'data_collections';

  public getTemplate(id: DataCollection['id'], data: Record<string, unknown>) {
    const path = `${id}/template`
    const [url] = this.getUrl(path, data)
    return url
  }

  public uploadTemplate(id: DataCollection['id'], file: File, config?: AxiosRequestConfig) {
    const path = `${id}/template`
    const [url] = this.getUrl(path)
    const data = new FormData()
    data.append('file', file)
    return this.request<never, BR<UploadTemplateResponse>>('POST', url, { data, ...config })
  }

  public isAutoCurator(config?: AxiosRequestConfig) {
    const path = 'is-auto-curator'
    const [url] = this.getUrl(path)
    return this.request<null, { data: boolean }>('GET', url, config)
  }
}
